module.exports = __webpack_public_path__ + "img/2.d2dca8a2.png";